import styled from 'styled-components';
import { DataTable } from '@/components/TimeSeries/components/DataTable/styled';
import { Row } from '@simplywallst/ui-core';
interface Props {
  color?: string;
  active: boolean;
}

export const Dot = styled('span')<Props>`
  &:before {
    content: '';
    display: inline-block;
    width: ${({ theme }) => theme.x1spacePx}px;
    height: ${({ theme }) => theme.x1spacePx}px;
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    box-shadow: inset 0 0 1px 1px
      ${({ color, theme }) => color || theme.color.white};
    background: ${({ color, active, theme }) =>
      active ? color || theme.color.white : theme.color.charcoal};
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const Table = styled(DataTable)`
  thead tr th {
    &:nth-child(2) {
      text-align: right;
      color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
    }
  }
  tbody tr td {
    color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
    &:nth-child(1) {
      width: 30%;
    }
    &:nth-child(2) {
      width: 25%;
    }
    &:nth-child(3) {
      width: 45%;
    }
  }
  tr {
    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const AnalystPriceTargetsLoading = styled(Row)`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  height: calc(100% - 72px);
  background: ${({ theme }) => theme.color.charcoalRGBA(0.8)};
  z-index: 6999;
  p {
    margin-top: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const StyledTd = styled('td')<{ color: string }>`
  color: ${({ color }) => `${color} !important`};
`;
